import { useEffect, useState } from "react";
import { FaCar } from "react-icons/fa";
import { PiArrowFatLinesUpFill } from "react-icons/pi";
import "react-responsive-modal/styles.css";
import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "../redux/store";
import MyModal from "./MyModal";
import { useTranslation } from "react-i18next";

const UpgradesModal = () => {
  const location = useLocation();

  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);
  const upgrades = booking.bookingUpgrades;

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const requestedBefore = sessionStorage.getItem("lmxancillaries");

  useEffect(() => {
    if (!booking.isCanceled) {
      setModalIsOpen(upgrades.hasTransferUpgrade);
    }
  }, [booking]);

  if (location.pathname !== "/booking-details") {
    return null; // Do not show modal on other pages
  }

  if (requestedBefore) {
    return null;
  }

  return (
    <MyModal isOpen={modalIsOpen} onClose={() => setModalIsOpen(false)}>
      <div className="d-flex justify-content-between align-items-center gap-4">
        <div>
          <h2>{t("bookingDetails.transfers.transferUpgradeTitle")}</h2>
          <p className="mb-0">
            {t("bookingDetails.transfers.transferUpgradeNotice")}
          </p>
          <p>
            {t("bookingDetails.transfers.transferUpgradeNotice2", {
              price: upgrades.transferPerPerson,
            })}
          </p>
          {upgrades.hasTransferUpgrade && (
            <button
              className="secondaryBtn"
              onClick={() => setModalIsOpen(false)}
            >
              <Link to="/upgrades">
                {" "}
                {t("bookingDetails.transfers.transferUpgradeBtn")}
              </Link>
            </button>
          )}
        </div>

        <div className="d-none d-md-block">
          <FaCar className="text-info display-1" />
          <PiArrowFatLinesUpFill className="text-success display-1" />
        </div>
      </div>
    </MyModal>
  );
};

export default UpgradesModal;
